import { PlainTextPopoverTrigger } from '@ardoq/popovers';

/** @see PlainTextPopoverTrigger — kept as a named alias for existing imports. */
export const SettingsBarPopover = PlainTextPopoverTrigger;
